<template>
  <div class="works-filter">
    <div class="works-filter__blocks">
      <filter-artists-arttype label_class="works-filter__label"/>
      <!--<filter-country8/>-->
      <filter-pl-region-sub :title="$t('message.DeliveryPlRegionWorks')"/>
      <filter-period title_class="works-filter__block-item works-filter__block-title" label_class="works-filter__labels"/>

      <filter-genre label_class="works-filter__labels" :is_show="false" @updated="childupdated" :is_all_on_top="true"/>
      <filter-style label_class="works-filter__labels" :is_show="false" @updated="childupdated" :is_all_on_top="true"/>
      <filter-technique label_class="works-filter__labels" :is_show="false" @updated="childupdated" :is_all_on_top="true"/>

      <div class="works-filter__block works-filter__block-advanced-filter">
        <a class="works-filter__block-title works-filter__block-hide" v-on:click="toggleFilters" :class="{ active: advanced }">
          <span class="item-text">{{ advanced? $t("message.AdvancedFilter") : $t("message.ToggleFilter") }}</span>
          <span class="icon-angle-down">
            <img src="/res/subdomains/img/light/filter-arrow.svg" alt="img/header-item__arrow.svg"/>
          </span>
        </a>
      </div>
    </div>
  </div>
</template>


<script>
  import WorksFilterMix from "../../../../components/list/WorksFilterMix";
  import WorksComputedMix from "../../../../components/WorksComputedMix";

  import FilterGenre from "../../../../components/list/filter/FilterGenre";
  import FilterStyle from "../../../../components/list/filter/FilterStyle";
  import FilterTechnique from "../../../../components/list/filter/FilterTechnique";
  import FilterPeriod from "../../../../components/list/filter/FilterPeriod";
  //import FilterCountry8 from "../../../../components/list/filter/FilterCountry8";
  import FilterArtistsArttype from "./filter/FilterArtistsArttype";
  import FilterPlRegionSub from "./filter/FilterPlRegionSub";

  export default {
    components: {
      FilterPlRegionSub,
      FilterArtistsArttype,
      FilterGenre,
      FilterStyle, FilterTechnique, FilterPeriod,
      //FilterCountry8,
    },
    name      : 'artists-filtersub',
    mixins: [WorksFilterMix, WorksComputedMix],
  }
</script>



// WEBPACK FOOTER //
// src/sub/air_dark/components/list/ArtistsFilterSub.vue